// extracted by mini-css-extract-plugin
export default {"button":"_3ycg_","arrow":"_16-hr"};